module.exports = __webpack_public_path__ + "media/images/challenges/golden-ticket-22/wacom-logo-e2dee6a198bba47d115a8c647478fc7f.svg";